export const ALPHANUMERIC = /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ]*$/;
export const ALPHANUMERIC_WITH_SPACES = /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ]*$/;
